import BudgetsPages from "../../../components/budgetsForm/pages";
    
const Budgets = (props: any) => {
    return <BudgetsPages {...props} persona="control-tower" />;
};

export default Budgets;